
import device from 'bits/device'
import { navigateTo } from 'bits/location'
import { Component, namespace, Vue } from 'bits/vue'
import OzDrawerStatic from 'library/v4/components/OzDrawerStatic.vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzListRow from 'library/v4/components/OzListRow.vue'
import OzPopoverModal from 'library/v4/components/OzPopoverModal.vue'
import LocaleMenu from 'vuecomponents/LocaleMenu.vue'

type ActionItem = {
  text: string
  onClick: () => void
}

const localeStore = namespace('locale')
const browserStore = namespace('browser')

@Component({
  components: { OzDrawerStatic, OzPopoverModal, OzListRow, OzIcon, LocaleMenu },
})
export default class AuthActionMenu extends Vue {
  // This component comes as a pair with the vuexstore/modules/locale.ts.
  // Items from other parts of the vuex store should be passed in as props.
  @localeStore.State isSelectorOpen!: boolean
  @localeStore.State currentLocale!: string
  @localeStore.Getter currentLocaleName!: string
  @localeStore.Action openLocaleMenu!: () => void
  @localeStore.Action closeLocaleMenu!: () => void
  @localeStore.Action changeLocale!: (lang: string) => Promise<void>
  @browserStore.Getter isSmallerThanTabletPortrait!: boolean
  @browserStore.Getter windowHeight!: number

  get actionList(): ActionItem[] {
    return [
      {
        text: this.__('Help'),
        onClick: (): void => {
          navigateTo('https://padlet.help', { target: '_blank' })
        },
      },
      {
        text: this.__('Accessibility'),
        onClick: (): void => {
          navigateTo('https://padlet.com/about/accessibility', { target: '_blank' })
        },
      },
      {
        text: this.__('Language'),
        onClick: (): void => {
          this.openLocaleMenu()
        },
      },
    ]
  }

  get isPhone(): boolean {
    return device.phone || this.isSmallerThanTabletPortrait
  }

  cancel(): void {
    this.closeLocaleMenu()
    this.$emit('cancel')
  }

  async handleChangeLocale(lang: string): Promise<void> {
    await this.changeLocale(lang)
    this.$emit('change-locale')
  }
}
